import { faCircleXmark } from '@fortawesome/pro-thin-svg-icons';

import { SUPPORT_EMAIL } from '@constants';

import { Link } from '@components';
import { EmptyContent } from '@components/Ui';

export const FallbackError = () => {
  return (
    <EmptyContent
      variant="layout"
      icon={faCircleXmark}
      title="Something went wrong"
    >
      <p slot="text">
        For further assistance, please contact support at{' '}
        <Link
          external
          theme
          to={`mailto:${SUPPORT_EMAIL}`}
          className="text-primary underline hover:no-underline"
        >
          {SUPPORT_EMAIL}
        </Link>
      </p>
    </EmptyContent>
  );
};
